import { TransitionChild, Transition as TransitionRaw } from '@headlessui/react'
export type { TransitionChildProps, TransitionClasses, TransitionEvents, TransitionRootProps } from '@headlessui/react'

export const Transition = Object.assign(TransitionRaw, {
  Child: TransitionChild
})
